import {Button, Stack} from '@mui/material';
import {useObservable} from '@ngneat/react-rxjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {finalize} from 'rxjs';

import {clientsQuery, clientsService} from '@store/clients';
import {Download} from '@icons/index';
import ClientsListTable from '@screens/admin/clients/list/ClientsList.table';

const ClientsListTab = () => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();

  const [CSVLoading, setCSVLoading] = useState(false);

  const [filterStatus] = useObservable(clientsQuery.status$);
  const [selectedClients] = useObservable(clientsQuery.selectedClients$);

  const handleExportCSV = () => {
    setCSVLoading(true);
    clientsService.getClientsCSV()
      .pipe(finalize(() => setCSVLoading(false)))
      .subscribe({
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (
    <Stack flex={1} width="100%" spacing={2} mt="-35px">
      <Stack alignSelf="flex-end" direction="row" alignItems="center" spacing={2}>
        <Button
          variant="outlined" color="primary"
          disabled={CSVLoading}
          onClick={handleExportCSV}
          startIcon={<Download/>}>
          {t('global.exportCSV')}
        </Button>
      </Stack>
      <Stack flex={1} spacing={3}>
        {/*<TabsComponent*/}
        {/*  ariaLabel="secondary"*/}
        {/*  handleChange={(value) => clientsService.setStatus(GlobalStatus.tabs[value])}*/}
        {/*  value={GlobalStatus.tabs.indexOf(filterStatus ?? undefined)}*/}
        {/*  tabs={[t('routes.all')]}/>*/}
        <Stack flex={1}>
          <ClientsListTable/>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ClientsListTab;
